import React, { useEffect, useState } from "react";
import { Form } from "antd";
import { lookupIfsc } from "../../util/ifscValidation";

/**
 * Small "Bank, Branch, City" line shown under an IFSC input once the code is a
 * confirmed match. Render it in the field's `extra`; it reads the field from the
 * surrounding Form.
 * @param {{ name: string, candidate?: boolean }} props
 */
const IfscBankInfo = ({ name, candidate = false }) => {
  const form = Form.useFormInstance();
  const value = Form.useWatch(name, form);
  const [details, setDetails] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setDetails(null);
    if (!value || String(value).trim().length !== 11) return undefined;
    lookupIfsc(value, { candidate }).then((result) => {
      if (!cancelled) setDetails(result.details);
    });
    return () => {
      cancelled = true;
    };
  }, [value, candidate]);

  if (!details) return null;
  const place = [details.branch, details.city].filter(Boolean).join(", ");
  return (
    <span style={{ color: "#389e0d" }}>
      {details.bank}
      {place ? `, ${place}` : ""}
    </span>
  );
};

export default IfscBankInfo;
